@import '../../../styles/colors';
@import '../../../styles/fonts';

// Please keep this file together, panel and item styles are interconnected

.panel {
  overflow-x: hidden !important;
  box-shadow: none !important;
  border-right: 1px solid $sg2-color-grey-l2;
  position: relative;
  z-index: 800;
  transition:
    width 0.15s ease,
    flex-basis 0.15s ease;
}

.panel:not(.panel_collapsed) {
  width: 248px;
  flex-basis: 248px;
}

.title {
  padding: 16px 8px 8px 16px;

  + .group {
    padding-top: 0;
  }
}

.group {
  padding: 16px 8px 16px 16px;
  transition: padding 0.15s ease;

  & + & {
    margin-top: -16px;
  }
}

.groupTitle {
  padding: 2px 8px 2px 12px;
  color: rgb(0, 0, 0, 0.6);
  opacity: 1;
  transition: opacity 0.15s ease;
  overflow: hidden;
}

.subgroup {
  padding: 4px 8px 4px 32px;
  margin: 0 -8px 16px -16px;
  background: #fff;
  transition:
    padding 0.15s ease,
    background-color 0.15s ease;
}

.note {
  padding: 12px 8px;

  .title + & {
    margin-top: -8px;
  }

  .group + & {
    margin-top: -16px;
  }
}

.itemWrapper {
  width: 100%;
}

.item {
  appearance: none;
  display: flex;
  min-height: 40px;
  align-items: center;
  width: 100%;
  gap: 16px;
  border: 0;
  background: none;
  box-sizing: border-box;
  border-radius: 6px;
  color: rgb(0, 0, 0, 0.6);
  padding: 0 8px;
  text-align: left;
}

button.item {
  cursor: pointer;
  transition:
    color 0.1s ease,
    background-color 0.1s ease;

  &:hover {
    color: #000;
    background-color: $sg2-color-grey-l2;
  }
}

.itemIcon,
.itemRight {
  width: 24px;
  text-align: center;
  flex: 0 0 24px;

  i {
    vertical-align: middle;
  }
}

.itemIconBadge {
  > :last-child {
    display: none;
  }
}

.itemIcon20 {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

.itemLabel {
  flex: 1;
  min-width: 110px;

  > * {
    line-height: 20px;
  }
}

.item_selected {
  color: $sg2-color-blue !important;
}

// overflow
.overflowButton {
  display: none;
}

.totalHeight {
  height: 100%;
  overflow: visible;
}

// isCollapsed
.panel.panel_collapsed {
  width: 62px;
  flex-basis: 62px;
  overflow: visible;

  .title {
    padding-left: 13px;
    padding-right: 13px;

    .itemIcon {
      display: none;
    }

    .itemRight {
      display: block;
    }
  }

  .item {
    min-height: 36px;
    margin: 2px 0;
    padding: 0 6px;

    + .item {
      margin-top: 4px;
    }
  }

  .itemIconBadge {
    > :last-child {
      display: block;
    }
  }

  .itemLabel,
  .itemRight {
    display: none;
  }

  .group {
    padding-left: 13px;
    padding-right: 13px;
  }

  .groupTitle {
    opacity: 0;
  }

  .subgroup {
    padding: 4px 13px;
    margin: 0 -13px 16px;
    background: $sg2-color-grey-l2;
  }

  &.panel_withEllipsis {
    .overflowContainer {
      max-height: calc(100% - 60px);
      overflow: hidden;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 24px;
        pointer-events: none;
        background: linear-gradient(
          to top,
          rgb(255, 255, 255, 1),
          rgb(255, 255, 255, 0)
        );
      }
    }

    .overflowButton {
      display: block;
      position: absolute;
      left: 19px;
      bottom: 16px;
    }
  }
}

// scrollingColumnCell
// .scrollingColumnCell {
// 	> :first-child {
// 		display: none !important;
// 	}
// }

// loadingItem
.itemLoading {
  padding: 10px 16px 10px 24px;
  display: flex;
  min-height: 40px;
  align-items: center;
  gap: 24px;
  box-sizing: border-box;
}

.itemLoadingIcon {
  width: 20px;
  flex: 0 0 20px;
}

.itemLoadingLabel {
  flex: 1;
}
